import { render, staticRenderFns } from "./UcInvoiceExchangeRateEditor.yaml?vue&type=template&id=bf03d584&component"
import script from "./UcInvoiceExchangeRateEditor.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceExchangeRateEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports